export default "__VITE_ASSET__nyDcXVQc__"